"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const hooks_1 = require("../../hooks");
const useId_1 = require("../../hooks/useId");
const RadioGroup_1 = require("./RadioGroup");
const sharedRadioButtonStyles = {
    display: "inline-flex",
    alignItems: "center",
    marginRight: "spacing-4",
    width: "spacing-6",
    height: "spacing-6",
    border: "2px solid",
    borderRadius: "radius-round",
    cursor: "pointer",
    ":focus-visible": {
        outline: "2px solid",
        outlineColor: "focus",
        outlineOffset: "2px"
    }
};
const buttonWrapper = {
    display: "flex",
    flexDirection: "column",
    width: "fit-content"
};
const RadioButton = (props) => {
    const { value, label, disabled, error, onBlur, id } = props;
    const base0Id = (0, useId_1.useId)();
    const inputId = id !== null && id !== void 0 ? id : base0Id;
    const [, preventOutlineOnClick, handleFocus, handleBlur] = (0, hooks_1.useFocusControls)(onBlur);
    const radioContext = react_1.default.useContext(RadioGroup_1.RadioGroupContext);
    const isChecked = react_1.default.useMemo(() => {
        return (radioContext === null || radioContext === void 0 ? void 0 : radioContext.selectedValue) === value;
    }, [radioContext === null || radioContext === void 0 ? void 0 : radioContext.selectedValue, value]);
    const isDisabled = react_1.default.useMemo(() => {
        return (radioContext === null || radioContext === void 0 ? void 0 : radioContext.disabled) || disabled;
    }, [disabled, radioContext === null || radioContext === void 0 ? void 0 : radioContext.disabled]);
    const isError = react_1.default.useMemo(() => {
        return Boolean((radioContext === null || radioContext === void 0 ? void 0 : radioContext.error) || error);
    }, [radioContext === null || radioContext === void 0 ? void 0 : radioContext.error, error]);
    const defaultRadioButtonStyles = react_1.default.useMemo(() => {
        return Object.assign(Object.assign({}, sharedRadioButtonStyles), { borderColor: isChecked ? "input-surface-enabled" : "input-stroke-enabled", transition: "transition-color-medium", ":hover": {
                borderColor: isChecked ? "input-surface-hover" : "input-stroke-hover",
                ":after": {
                    backgroundColor: "input-surface-hover"
                }
            }, ":active": {
                borderColor: isChecked ? "input-surface-click" : "input-stroke-click",
                ":after": {
                    backgroundColor: "input-surface-click"
                }
            }, ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: "input-surface-enabled",
                visibility: isChecked ? "visible" : "hidden",
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            } });
    }, [isChecked]);
    const disabledRadioButtonStyles = react_1.default.useMemo(() => {
        return Object.assign(Object.assign({}, sharedRadioButtonStyles), { borderColor: "input-stroke-disabled", cursor: "not-allowed", ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: isChecked ? "input-surface-disabled" : undefined,
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            } });
    }, [isChecked]);
    const errorRadioButtonStyles = react_1.default.useMemo(() => {
        return Object.assign(Object.assign({}, sharedRadioButtonStyles), { borderColor: "input-stroke-error", "&:active": {
                backgroundColor: "backgroundNeutral02"
            }, ":after": {
                content: `""`,
                marginLeft: "spacing-1",
                width: "spacing-4",
                height: "spacing-4",
                backgroundColor: isChecked ? "input-stroke-error" : undefined,
                borderRadius: "radius-round",
                transition: "transition-color-medium"
            } });
    }, [isChecked]);
    const radioButtonStyles = react_1.default.useMemo(() => {
        if (isDisabled) {
            return disabledRadioButtonStyles;
        }
        else if (isError) {
            return errorRadioButtonStyles;
        }
        else {
            return defaultRadioButtonStyles;
        }
    }, [
        defaultRadioButtonStyles,
        disabledRadioButtonStyles,
        errorRadioButtonStyles,
        isDisabled,
        isError
    ]);
    const labelStyles = react_1.default.useMemo(() => {
        return {
            display: "inline-flex",
            alignItems: "center",
            color: isDisabled ? "input-text-disabled" : "input-text",
            cursor: isDisabled ? "not-allowed" : "pointer",
            fontSize: "font-size-4",
            lineHeight: "leading-2",
            letterSpacing: "kerning-none",
            paddingY: "spacing-3"
        };
    }, [isDisabled]);
    return (react_1.default.createElement(foundations_1.Box, { onMouseDown: preventOutlineOnClick, onMouseUp: preventOutlineOnClick, sx: buttonWrapper },
        react_1.default.createElement(foundations_1.Box, { as: "label", htmlFor: inputId, id: `${inputId}-label`, sx: labelStyles },
            react_1.default.createElement(foundations_1.Box, { as: "input", type: "radio", id: inputId, value: value, checked: isChecked, onChange: radioContext === null || radioContext === void 0 ? void 0 : radioContext.onChange, onFocus: handleFocus, onBlur: handleBlur, sx: radioButtonStyles, disabled: isDisabled, "aria-disabled": isDisabled }),
            label)));
};
exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map